import React from "react";
import Background from "../Background";
import ContactUsTable from "./ContactUsTable";

const ContactUsManagement = () => {
  return (
    <Background heading={"Contact Us Management"} key="contact-us-management">
      <ContactUsTable length={30} />
    </Background>
  );
};

export default ContactUsManagement;
